export const cashSecurity:string = 'Cash'
export const propertySecurity:string = 'Property'
